module.exports = __webpack_public_path__ + "static/img/sistema-ko.98a53ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sistema-ko.svg
// module id = dHFg
// module chunks = 1